import { render } from "./CadastroPessoaModal.vue?vue&type=template&id=8d54ed42&ts=true"
import script from "./CadastroPessoaModal.vue?vue&type=script&lang=ts"
export * from "./CadastroPessoaModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__